
export const getEditStaticPage = `
query getEditStaticPage ($id: Int!) {
    getEditStaticPage (id: $id) {
        result{
          id
          pageName
          content
          metaTitle
          metaDescription
          createdAt
          pageBanner
          dynamicStaticContent{
          id
          contentId
          language
          content
              }
        }
    }
  }`;